<div class="container-fluid">

  <h4 id="upper">Validation PTA</h4>


  <!-- <div style="padding-top: 10px;" class="d-flex justify-content-center align-items-center" >
    <div class="container">
      <div class="row justify-content-center">
        <div class="card p-4">

        </div>
      </div>
    </div>
  </div> -->


  <!-- loading area -->

  <!-- end loading area -->

  <div class="container" *ngIf="isLoading === false">
    <div class="card" > <!-- Augmenter la hauteur de la carte -->
      <div class="d-flex justify-content-center align-items-center h-100 p-4">
        <div class="d-flex gap-3">
          <select class="form-select" name="projet" [(ngModel)]="programme_id" id="projet">
            <option disabled value="">Sélectionner un Programme</option>
            <option *ngFor="let item of pojetItems" [ngValue]="item">{{item.libelle}}</option>
          </select>
          <button (click)="validatePta()" class="btn btn-success">Valider</button>
        </div>
      </div>
      <div *ngIf="showTextCard === true" class="d-flex flex-column justify-content-center align-items-center text-center loading_area">
        <i class="pi pi-check-circle" style="font-size: 2rem; color: green;"></i>
        <h4 style="color: green;" class="mt-5">Les données ont validées avec succès</h4>
      </div>
    </div>
  </div>
    <!-- zone affichage du compte des operations en attente de validation -->
    <div class="row justify-content-center" *ngIf="isLoading ===false">

      <!-- tableau simple pour les programmes -->
      <div *ngIf="validationData?.programme?.length > 0" class="col-12 mb-4">
        <div class="card">
          <div class="card-header">
            <h5 class="">Programmes en attente de validation ({{validationData?.programme?.length}})</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-light">
                  <tr>
                    <th>Code</th>
                    <th>Libellé</th>
                    <th>Structure responsable</th>
                    <th>Poids</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of validationData?.programme">
                    <td>{{ item.code }}</td>
                    <td>{{ item.libelle }}</td>
                    <td>{{ item.structure_responsable }}</td>
                    <td>{{ item.total_poids | number:'1.0-0' }}</td>
                    <td>
                      <button (click)="openDetailsProjets()" class="btn btn-sm btn-success">Voir détails</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- tableau simple pour les activités -->
      <div *ngIf="validationData?.activites?.length > 0" class="col-12 mb-4">
        <div class="card">
          <div class="card-header">
            <h5 class="">Activités en attente de validation ({{validationData?.activites?.length}})</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-light">
                  <tr>
                    <th>Code</th>
                    <th>Libellé</th>
                    <th>Structure responsable</th>
                    <th>Poids</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of validationData?.activites">
                    <td>{{ item.code }}</td>
                    <td>{{ item.libelle }}</td>
                    <td>{{ item.structure_responsable }}</td>
                    <td>{{ item.total_poids | number:'1.0-0' }}</td>
                    <td>
                      <button (click)="openDetailsActivites()" class="btn btn-sm btn-success">Voir détails</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- tableau simple pour les sous-activités -->
      <div *ngIf="validationData?.sous_activites?.length > 0" class="col-12 mb-4">
        <div class="card">
          <div class="card-header">
            <h5 class="">Sous-activités en attente de validation ({{validationData?.sous_activites?.length}})</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead class="thead-light">
                  <tr>
                    <th>Code</th>
                    <th>Libellé</th>
                    <th>Structure responsable</th>
                    <th>Poids</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of validationData?.sous_activites">
                    <td>{{ item.code }}</td>
                    <td>{{ item.libelle }}</td>
                    <td>{{ item.structure_responsable }}</td>
                    <td>{{ item.total_poids | number:'1.0-0' }}</td>
                    <td>
                      <button (click)="openDetailsSousActivites()" class="btn btn-sm btn-success">Voir détails</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!-- end zone -->

    <div class="d-flex justify-content-center" *ngIf="isLoading ===true">
      <div class="container">
        <div class="row">
          <div class="text-center loading_area mt-10">
            <img class="sized_image" src="/assets/images/loading_data.png">
            <h4 class="mt-4">Veuillez patienter...</h4>
            <div class="loader4"></div>
          </div>
        </div>
      </div>
    </div>
</div>


<!-- debut sous activites -->
<ng-template #sousActivitesModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Sous-activités({{validationData?.sous_activites?.length}})</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead class="thead-light">
          <tr>
            <th>Code</th>
            <th>Libellé</th>
            <th>Struct. resp.</th>
            <th>Poids</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedSousActivites">
            <td>{{ item.code }}</td>
            <td>{{ item.libelle }}</td>
            <td>{{ item.structure_responsable }}</td>
            <td>{{ item.total_poids | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex justify-content-center" *ngIf="isLoading === true">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor">Chargement en cours</h5>
              <div class="loader4"></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="paginatedSousActivites.length === 0 && isLoading === false" class="d-flex justify-content-center">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor">Aucune donnée trouvée</h5>
            </div>
          </div>
        </div>

      </div>
      <p-paginator (onPageChange)="onPageChangeSousActivites($event)" [first]="firstSousActivites"
        [rows]="rowsSousActivites" [totalRecords]="totalRecords1" [rowsPerPageOptions]="[10, 20, 30]">
      </p-paginator>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
  </div>
</ng-template>
<!-- fin sous activites -->


<!-- debut activites -->
<ng-template #activitesModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Activités({{validationData?.activites?.length}})</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">

    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead class="thead-light">
          <tr>
            <th>Code</th>
            <th>Libellé</th>
            <th>Struct. resp.</th>
            <th>Poids</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedActivites">
            <td>{{ item.code }}</td>
            <td>{{ item.libelle }}</td>
            <td>{{ item.structure_responsable }}</td>
            <td>{{ item.total_poids | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center" *ngIf="isLoading === true">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor">Chargement en cours</h5>
              <div class="loader4"></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="paginatedActivites.length === 0 && isLoading === false" class="d-flex justify-content-center">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor">Aucune donnée trouvée</h5>
            </div>
          </div>
        </div>

      </div>
      <p-paginator (onPageChange)="onPageChangeActivites($event)" [first]="firstActivites" [rows]="rowsActivites"
        [totalRecords]="totalRecords2" [rowsPerPageOptions]="[10, 20, 30]">
      </p-paginator>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
  </div>
</ng-template>
<!-- fin activites -->

<!-- debut projets -->
<ng-template #projetsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Programmes({{validationData?.programme?.length || 0}})</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">

    <div class="table-responsive">
      <table class="table table-bordered table-striped">
        <thead class="thead-light">
          <tr>
            <th>Code</th>
            <th>Libellé</th>
            <th>Struct. resp.</th>
            <th>Poids</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of paginatedProjets">
            <td>{{ item.code }}</td>
            <td>{{ item.libelle }}</td>
            <td>{{ item.structure_responsable }}</td>
            <td>{{ item.total_poids | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center" *ngIf="isLoading === true">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor">Chargement en cours</h5>
              <div class="loader4"></div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="paginatedProjets.length === 0 && isLoading === false" class="d-flex justify-content-center">
        <div class="container">
          <div class="row">
            <div class="text-center">
              <h5 id="graycolor">Aucune donnée trouvée</h5>
            </div>
          </div>
        </div>

      </div>
      <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
        [totalRecords]="totalRecords3" [rowsPerPageOptions]="[10, 20, 30]">
      </p-paginator>
    </div>

  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Fermer</button>
  </div>
</ng-template>
<!-- fin projets -->



<p-confirmDialog />
<p-toast />

<!-- Statistics Cards -->
<div class="container-fluid mt-4" *ngIf="data_to_reviewed">
  <h5 class="text-center">Statistiques des données problématiques</h5>
  <div class="row">
    <!-- Programmes Card -->
    <div class="col-md-4" *ngIf="data_to_reviewed.programme && data_to_reviewed.programme.length > 0">
      <div class="card custom-card">
        <div class="card-header custom-card-header">
          <h5 class="mb-0">Programmes ({{data_to_reviewed.programme.length}})</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-light">
                <tr>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Poids</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let prog of data_to_reviewed.programme">
                  <td>{{ prog.code }}</td>
                  <td>{{ prog.libelle }}</td>
                  <td>{{ prog.total_poids | number:'1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="data_to_reviewed.programme.length === 0" class="d-flex justify-content-center">
            <p class="text-muted text-center">Aucune donnée</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Actions Card -->
    <div class="col-md-4" *ngIf="data_to_reviewed.actions && data_to_reviewed.actions.length > 0">
      <div class="card custom-card">
        <div class="card-header custom-card-header">
          <h5 class="mb-0">Actions ({{data_to_reviewed.actions.length}})</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-light">
                <tr>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Poids</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let action of data_to_reviewed.actions">
                  <td>{{ action.code }}</td>
                  <td>{{ action.libelle }}</td>
                  <td>{{ action.total_poids | number:'1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noAction>
            <p class="text-muted text-center">Aucune donnée</p>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- Activites Card -->
    <div class="col-md-4" *ngIf="data_to_reviewed.activites && data_to_reviewed.activites.length > 0">
      <div class="card custom-card">
        <div class="card-header custom-card-header">
          <h5 class="mb-0">Activités ({{data_to_reviewed.activites.length}})</h5>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped">
              <thead class="thead-light">
                <tr>
                  <th>Code</th>
                  <th>Libellé</th>
                  <th>Poids</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let activite of data_to_reviewed.activites">
                  <td>{{ activite.code }}</td>
                  <td>{{ activite.libelle }}</td>
                  <td>{{ activite.total_poids | number:'1.0-0' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-template #noActivite>
            <p class="text-muted text-center">Aucune donnée</p>
          </ng-template>
        </div>
      </div>
    </div>
</div>

